import { NumericTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { debounce } from 'throttle-debounce';
import { useSelector, useDispatch } from "react-redux"




import './index.scss'

export interface DebouncedInputProps{
    step?:number, 
    maximum?:number, 
    minimum?: number, 
    isDisabled?: boolean, 
    useCeiling?: boolean
    onValueChanged?: (value: number) => void, 
    currentValue?: number, 
    validateInput?: (value?: number) => boolean, 
    displayError?: () => void,
    setTypingInProgress?:(inProgress:boolean)=>void,
    className?: string,
    noDecimal?: boolean,
    // placeHolder?: string
}

export const DebouncedInput = (props: DebouncedInputProps) => {

    const { noDecimal, step, className, useCeiling, isDisabled, onValueChanged = () => { }, currentValue, validateInput = () => true, displayError = () => { }, setTypingInProgress, ...remaining } = props
    const [inputValue, setInputValue] = useState(currentValue);
    const valueChangedCallback = useRef(onValueChanged);
    const validateInputCallback = useRef(validateInput);
    const displayErrorCallback = useRef(displayError);
    const setTypingCallback= useRef(setTypingInProgress);
    const product = useSelector((state:any) => state.product) 

    const fabricStep = useSelector((state: any) => state.fbdata?.fabricStep);
    const fabricMinLength = useSelector((state: any) => state.fbdata?.fabricMinLength);
    const fabricAllowPartialSegment = useSelector((state: any) => state.fbdata?.fabricAllowPartialSegment);

    useEffect(() => {
        setInputValue(currentValue)
    }, [currentValue])


    valueChangedCallback.current = onValueChanged;
    validateInputCallback.current = validateInput;
    displayErrorCallback.current = displayError;

    const debounceFunc = useCallback(debounce(1000, (currentValue: number, value: number) => {
        value = useCeiling? Math.ceil(value*10)/10 : value
        if (validateInputCallback.current(value)) {
            setInputValue(value)
            valueChangedCallback.current(value);
        } else {
            setInputValue(currentValue)
            displayErrorCallback.current();
        }
        setTypingCallback.current && setTypingCallback.current(false)
    }), [useCeiling]);

    


    return <NumericTextBoxComponent
        //step={step?step:1}
        step={fabricStep}
        className={className}
        data-is-valid={validateInput(inputValue)}
        value={inputValue}
        showSpinButton={(className=='inputNumber')?false:true}
        validateDecimalOnType
        //Guy for LC
        //decimals={noDecimal?0:2}
        //min={noDecimal?1:0.5}
        decimals={(className=='inputNumber')?2:(fabricAllowPartialSegment)?2:0}//{0}   
        //min={(className=='inputNumber')?0.1:1}//{1}
        min={(className=='inputNumber')?0.1:fabricMinLength}//{1}
        format="N"
        focus={({value})=>{
            setTypingCallback.current && setTypingCallback.current(true)
        }}
        blur={({value})=>{
            if(value === currentValue){
                setTypingCallback.current && setTypingCallback.current(false)
            }
        }}
        // placeholder={placeHolder}      
        onChange={(inputEvent:any) => {
            
            // inputEvent.preventDefault()
            let valueKeyedIn = inputEvent.target.value;
            let newValue = 1;
            if (product.totalLength>100)
            {
                newValue = parseFloat(valueKeyedIn);
                inputEvent.target.min = product.fabricMinLength;
                inputEvent.target.step = fabricStep;
            }
            else
            {
                newValue = Math.ceil(valueKeyedIn);
                inputEvent.target.min = 1;
                inputEvent.target.step = 1;
            }

            setInputValue(newValue)

            debounceFunc(currentValue, newValue)
            
            setTypingCallback.current && setTypingCallback.current(true)    
                       
        }}


        {...remaining}
    />
}